import { render, staticRenderFns } from "./ReviewDetailBookContext.vue?vue&type=template&id=374b036c&scoped=true&"
import script from "./ReviewDetailBookContext.vue?vue&type=script&lang=js&"
export * from "./ReviewDetailBookContext.vue?vue&type=script&lang=js&"
import style0 from "./ReviewDetailBookContext.vue?vue&type=style&index=0&id=374b036c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374b036c",
  null
  
)

export default component.exports